import { render, staticRenderFns } from "./StockManagerView.vue?vue&type=template&id=71aa254b&scoped=true"
import script from "./StockManagerView.vue?vue&type=script&lang=js"
export * from "./StockManagerView.vue?vue&type=script&lang=js"
import style0 from "./StockManagerView.vue?vue&type=style&index=0&id=71aa254b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa254b",
  null
  
)

export default component.exports